import { dayjs } from 'shared/utils/date';
import { formatDateRange } from 'shared/constants/date';
import globalMessages from 'translations/messages';
import messages from './messages';

export const tooltipFormatter = ({ data: { numericValue, percentageValue } }) => `${numericValue}${percentageValue ? ` (${Math.round(percentageValue)}%)` : ''}`;

export const labelFormatter = (percentage, min) => ({ data: { numericValue, percentageValue } }) => {
  const roundedValue = Math.round(percentageValue);
  if (min === undefined || roundedValue >= min) {
    return percentage ? `${roundedValue}%` : numericValue;
  }
  return '';
};

export const axisFormatter = percentage => (value) => {
  let formatted = value;
  if (percentage) {
    formatted += '%';
  }
  return formatted;
};

export function getFilterSummaryDate(segment, locale) {
  if (!segment?.dateRange) {
    return '';
  }

  const { period, startDate, endDate } = segment.dateRange;

  return formatDateRange(dayjs, period, startDate, endDate, { weekDates: false, locale });
}

export const formatSegment = (segment, options = {}) => {
  const {
    lineBreak = '\n',
    includeDate = !segment?.isBenchmark,
    count = segment?.displayCount || segment?.uniqueCount,
    formatMessage,
    locale,
    countUnit = segment?.countUnit || 'response',
    isScoreGraph,
    onSelectChartSegment,
  } = options;

  if (!segment) return '';

  let formatted = segment.sortIndex === -1 && formatMessage ? formatMessage(globalMessages.staticSegmentName) : segment.name;

  if (count != null) {
    let countString;
    const countMessage = `${countUnit}Count`;
    if (formatMessage && messages[countMessage]) {
      countString = formatMessage(messages[countMessage], { count });
    } else {
      countString = count;
    }
    formatted += ` (${countString})`;
  }

  if (includeDate) {
    formatted += `${lineBreak}${getFilterSummaryDate(segment, locale)}`;
  }

  if (formatMessage && !isScoreGraph && onSelectChartSegment) {
    formatted += `${lineBreak}<em>${formatMessage(messages.clickToCreateSegment)}</em>`;
  }

  return formatted;
};
